const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemarkCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.229,
    height: 36.229,
    viewBox: "0 0 36.229 36.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__iconmonstr-warning-6_1_",
    d: "M18.115 3.019a15.1 15.1 0 1 1-15.1 15.1 15.113 15.113 0 0 1 15.1-15.1zm0-3.019a18.115 18.115 0 1 0 18.114 18.115A18.115 18.115 0 0 0 18.115 0zm-1.978 11.361a2.052 2.052 0 0 1 2.035-2.3 1.948 1.948 0 0 1 1.932 2.19l-1.143 9.137a.854.854 0 0 1-1.7 0l-1.129-9.024zm1.977 16.188A1.887 1.887 0 1 1 20 25.662a1.888 1.888 0 0 1-1.885 1.887z",
    "data-name": "iconmonstr-warning-6 (1)",
    style: {
      fill: "#ffcf03"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemarkCancel);
export default __webpack_public_path__ + "static/media/RemarkCancel.4ee4cd729a91d9d32927b96e50d5c528.svg";
export { ForwardRef as ReactComponent };